import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function ProofSection() {
  return <section className="w-full bg-white py-24 md:py-32 border-b border-neutral-100" data-id="element-135">
      <div className="max-w-7xl mx-auto px-6 text-center" data-id="element-136">
        <FadeIn data-id="element-137">
          <h2 className="text-2xl md:text-3xl font-medium text-neutral-900 mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-138">
            "Designed for founders, SMEs, and teams who want clarity,
            accountability, and software that actually works."
          </h2>
        </FadeIn>
        
        
        <Button href="https://cal.com/stasis-group-africa/15min" variant="secondary" data-id="element-139">Book a 15min Call</Button>
      </div>
    </section>;
}